export enum OrganizationTaxesTabsEnum {
  TAX_RATES = 'tax-rates',
  CATEGORY_TAX_DEFAULTS = 'category-tax-defaults',
}